import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * ErrorSources
 * Props:
 * - errorSources: [{hasError, error, fallback}] - list of possible error sources
 */
const ErrorSources = ({errorSources = []}) => {
    if (!Array.isArray(errorSources) || errorSources.length === 0) return null

    const triggered = errorSources.filter((s) => s && s.hasError)
    if (!triggered || triggered.length === 0) return null

    const renderText = (source, idx) => {
        const message =
            (source.error && source.error.message) || source.fallback || 'An error occurred.'
        return (
            <Box
                key={`error-source-${idx}`}
                className="error-wrapper"
                color="red.950"
                backgroundColor="red.18"
                padding="15px"
            >
                <Text as="p" fontSize="16px" fontWeight="400" lineHeight="25px">
                    {message}
                </Text>
            </Box>
        )
    }

    return renderText(triggered[0], 0)
}

ErrorSources.propTypes = {
    errorSources: PropTypes.arrayOf(
        PropTypes.shape({
            hasError: PropTypes.bool,
            error: PropTypes.object,
            fallback: PropTypes.string
        })
    )
}

export default ErrorSources
